// Sustituye valores a Null o vacios por el valor de variable replacement
function replaceNullAndEmpty(obj, replacement) {
        // Iterate through each property of the object
        for (let key in obj) {
        // Check if the property value is null or an empty string
        if (obj[key] === null || obj[key] === '') {
            // Replace null or empty string with the replacement string
            obj[key] = replacement;
        }
        }
        // Return the modified object
        return obj;
}


export {replaceNullAndEmpty};